import { jsx as _jsx } from "react/jsx-runtime";
import { Tabs, Tab, useTheme } from '@mui/material';
const PageTabs = ({ tabs, value, onChange, variant = 'scrollable', scrollButtons = 'auto', sx }) => {
    const theme = useTheme();
    // Normalize tabs to PageTabItem format
    const normalizedTabs = tabs.map((tab, index) => {
        if (typeof tab === 'string') {
            return { label: tab, value: tab };
        }
        return tab;
    });
    return (_jsx(Tabs, { value: value, onChange: onChange, variant: variant, scrollButtons: scrollButtons, sx: {
            minHeight: 'auto',
            '& .MuiTab-root': {
                minHeight: 48,
                textTransform: 'none',
                fontSize: '14px',
                fontWeight: 500
                // Non-active tab color
            },
            '& .MuiTab-root:not(.Mui-selected)': {
                color: theme.palette.text.primary
            },
            '& .MuiTab-root.Mui-selected': {
                color: theme.palette.text.primary // Active tab color
            },
            ...sx
        }, children: normalizedTabs.map((tab) => (_jsx(Tab, { label: tab.label, value: tab.value, disabled: tab.disabled }, tab.value))) }));
};
export default PageTabs;
